import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList } from 'recharts';

export const SimpleHorizontalBarChart = (props) => {
    return(
      <ResponsiveContainer width="90%">
       <BarChart data={props.data} layout='vertical' margin={{
            top: 5,
            right: 45,
            left: 10,
            bottom: 5,
          }}>
        <XAxis hide type="number"/>
        <YAxis type="category" dataKey="name" fontSize={8} angle="360" interval={0}/>
        <Bar dataKey="uv" fill="#4473ca" barSize={15} layout='vertical' name={props.name ?? ""}>
            <LabelList dataKey="uv" content={props.data} position='right' fontSize="small"/>
          </Bar>
      </BarChart>
      </ResponsiveContainer>
    )
};